export default __webpack_public_path__ + "static/game-image-2-ita-091477532d916f48dd1e03ed926378d1.png";